import { Button, TextField } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';

import { FormSection } from '@/components/form-elements/FormSection';
import { SidebarLayout } from '@/components/layouts/SidebarLayout';
import { QueryKeys } from '@/services/QueryKeys';
import { LocationsService } from '@/services/api';

type FormData = { name: string };

export function CreateLocationPage() {
  const navigate = useNavigate();
  const { organizationId } = useParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: ({ name }: FormData) =>
      LocationsService.create({ requestBody: { organizationId: organizationId as string, name } }),

    onSuccess: (location) => {
      navigate(`/arbeitgeber/${organizationId}/standorte/${location.id}`);

      return queryClient.invalidateQueries({ queryKey: QueryKeys.organizations.id(organizationId as string) });
    },
  });

  return (
    <SidebarLayout>
      <form
        id="main-form"
        onSubmit={handleSubmit((data) => {
          mutate(data);
        })}
      >
        <FormSection title="Standort erstellen">
          <TextField label="Standortname" {...register('name', { required: true })} error={!!errors.name} />
        </FormSection>

        <Button type="submit" variant="contained" size="large">
          Erstellen
        </Button>
      </form>
    </SidebarLayout>
  );
}
